import { IntlShape } from "react-intl";

import { FormErrors } from "@nens/ranalib";

import { ProjectFormValues } from "../types/project-form-values";

import { MAX_CHAR_CODE, MAX_CHAR_NAME } from "./project-consts";

export const validateProject = (values: ProjectFormValues, intl: IntlShape) => {
  const errors: FormErrors = {};
  if (!values.name) {
    errors.name = intl.formatMessage({
      id: "form.required.name",
      defaultMessage: "Name is required",
    });
  } else if (values.name.toString().length > MAX_CHAR_NAME) {
    errors.name = intl.formatMessage({
      id: "form.toolong.name",
      defaultMessage: "Name is too long",
    });
  }
  if (!values.code) {
    errors.code = intl.formatMessage({
      id: "form.required.code",
      defaultMessage: "Code is required",
    });
  } else if (values.code.toString().length > MAX_CHAR_CODE) {
    errors.code = intl.formatMessage({
      id: "form.toolong.code",
      defaultMessage: "Code is too long",
    });
  }

  return errors;
};
